import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import { TextArea } from "semantic-ui-react";

import WithFormField from "../WithFormField";

export function ControlledTextArea({
  name,
  defaultValue,
  required,
  errorMessage,
  ...props
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: defaultValue,
    rules: {
      validate: (value) => {
        return required ? Boolean(value.trim().length) || errorMessage : true;
      },
      required: { value: required, message: errorMessage },
    },
  });

  return (
    <div className="ui form">
      <TextArea
        {...props}
        className={error?.message ? "error" : ""}
        value={field.value || ""}
        onChange={field.onChange}
        onBlur={field.onBlur}
        ref={field.ref}
      />
    </div>
  );
}

ControlledTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
};

ControlledTextArea.defaultProps = {
  defaultValue: "",
  required: false,
  errorMessage: "",
};

export default WithFormField(ControlledTextArea);
